import {
  Badge,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  Box,
} from '@mui/material';
import {
  Home,
  Settings,
  Folder,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSwUpdateStore } from '@store/sw-update-store';

const DRAWER_WIDTH = 240;

export function SideNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const updateAvailable = useSwUpdateStore((s) => s.updateAvailable);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: DRAWER_WIDTH,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: DRAWER_WIDTH,
          boxSizing: 'border-box',
          borderRight: '1px solid',
          borderColor: 'divider',
        },
      }}
    >
      <Box sx={{ p: 2, pb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: 'primary.main' }}>
          {t('sideNav.title')}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {t('sideNav.subtitle')}
        </Typography>
      </Box>

      <Divider />

      <List>
        <ListItem disablePadding>
          <ListItemButton
            selected={isActive('/')}
            onClick={() => navigate('/')}
          >
            <ListItemIcon><Home /></ListItemIcon>
            <ListItemText primary={t('nav.home')} />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton
            selected={isActive('/session') || isActive('/sessions')}
            onClick={() => navigate('/sessions')}
          >
            <ListItemIcon><Folder /></ListItemIcon>
            <ListItemText primary={t('nav.sessions')} />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton
            selected={isActive('/settings')}
            onClick={() => navigate('/settings')}
          >
            <ListItemIcon>
              <Badge variant="dot" color="error" invisible={!updateAvailable}>
                <Settings />
              </Badge>
            </ListItemIcon>
            <ListItemText primary={t('nav.settings')} />
          </ListItemButton>
        </ListItem>
      </List>
    </Drawer>
  );
}
